import React, { useEffect, useState, useRef } from 'react';
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent,
    Popper,
    Grow,
    Divider
} from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { getTripStartDateFilterValues } from "../../../utils/utils";
import {
    TRIP_FILTER_STATUS,
    TRIP_FILTER_STATUS_MAPPING,
} from "../../../store/constants";

const useStyles = makeStyles((theme) => ({

    filterButton: {
        backgroundColor: "#fff",
        // margin: "0 3px",
        borderRadius: 30,
        textTransform: "capitalize",
        padding: "5px 10px"
    },
    arrowDropDownIconV1: {
        marginTop: -3
    },
    menuItemV1: {
        display: 'flex', justifyContent: 'flex-start', fontWeight: 300, paddingTop: 10, paddingBottom: 10
    },
    wV1: {
        width: '100%'
    },
    filterButtonVehicle: {
        textTransform: "capitalize",
        padding: "5px 10px",
        backgroundColor: "#fff",
        fontWeight: 300,
        paddingLeft: 16,
    },
}));

const TripStatusFilter = ({ status, fromReportsDialog, fromReportsSideBar, fromSinglePartyTripsTab, fromSingleSupplierTripsTab, defaultTripStatusFilter, fromTripListing }) => {

    const [selectedPDFFilterStatus, setSelectedPDFFilterStatus] = useState(defaultTripStatusFilter ? defaultTripStatusFilter : "ALL");
    const [open, setOpen] = useState(false);
    const anchorRef = React.useRef(null);
    const prevOpen = React.useRef(open);

    const classes = useStyles();

    useEffect(() => {
        if (defaultTripStatusFilter) {
            setSelectedPDFFilterStatus(defaultTripStatusFilter);
        }
    }, [defaultTripStatusFilter]);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, []);

    const handleFilterOpen = () => {
        setOpen(true)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    }

    const handleCloseFilter = () => {
        setOpen(false);
    }

    const handleItemClick = (value) => {
        setSelectedPDFFilterStatus(value);
        handleCloseFilter();
        status(value);
    }

    return (
        <>
            {(fromReportsDialog || fromReportsSideBar) &&
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    variant="outlined"
                    size="small"
                    className={classes.filterButton}
                    onClick={handleFilterOpen}
                >
                    {TRIP_FILTER_STATUS[selectedPDFFilterStatus]}
                    <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
                </Button>
            }

            {(fromSinglePartyTripsTab || fromSingleSupplierTripsTab || fromTripListing) &&
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    variant="outlined"
                    size="small"
                    className={classes.filterButtonVehicle}
                    onClick={handleFilterOpen}
                >
                    {TRIP_FILTER_STATUS[selectedPDFFilterStatus]}
                    <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
                </Button>
            }

            {open &&
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1000 }}>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} id="menu-list-grow">
                                        {Object.keys(TRIP_FILTER_STATUS).map((value, index) => (
                                            <div className={classes.wV1} >
                                                <MenuItem key={index} className={classes.menuItemV1} onClick={() => handleItemClick(value)}>{TRIP_FILTER_STATUS[value]}</MenuItem>
                                                <Divider light />
                                            </div>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            }

        </>
    )
}


export default TripStatusFilter;